/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

/**
 *
 * SocialConnectorForm
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { DetailHeader, InputField, CloseIconSVG } from 'cx-ui-components';
import DetailWrapper from '../../../../components/DetailWrapper';
import styled from 'styled-components';
import { FieldArray } from 'redux-form/immutable';
import { fromJS } from 'immutable';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrappedDetailHeader = styled(DetailHeader)`
  margin-left: 35px;
`;

const SocialConnectorContainer = styled.div`
  display: flex;
`;
const SocialConnectorFieldsContainer = styled.div`
  flex-basis: 300px;
  margin-bottom: 10px;
`;

const SocialConnectorField = ({ fields, disabled, userHasUpdatePermission, inherited }) => {
    return <DetailWrapper open data-automation="contactAttributesSVG">
        <WrappedDetailHeader
            text="Properties"
            inherited={inherited}
            userHasUpdatePermission={userHasUpdatePermission}
            onActionButtonClick={() => fields.push(fromJS({ label: '', value: '' }))}
        />
        {
         fields.map((label, index) => {
            return (
                <SocialConnectorContainer key={index}>
                    <SocialConnectorFieldsContainer>
                        <InputField
                            name={`${label}.label`}
                            label="Key"
                            componentType="input"
                            inputType="text"
                            labelWidth="auto"
                            data-automation="localizationLabelInput"
                            disabled={disabled}
                            onBlur={event => event.preventDefault()}
                        />
                    </SocialConnectorFieldsContainer>
                    <SocialConnectorFieldsContainer>
                        <InputField
                            name={`${label}.value`}
                            label="Value"
                            componentType="input"
                            inputType="text"
                            labelWidth="auto"
                            data-automation="valueLabelInput"
                            disabled={disabled}
                            onBlur={event => event.preventDefault()}
                        />
                    </SocialConnectorFieldsContainer>
                    {!inherited && (
                        <div style={{ marginLeft: '10px', position: 'relative', bottom: '-5px' }}>
                            <CloseIconSVG
                                onClick={() => fields.remove(index)}
                                size={10}
                                closeIconType={
                                    fields.get(index) && (!fields.get(index).get('label') || !fields.get(index).get('value'))
                                        ? 'primary'
                                        : 'secondary'
                                }
                                data-automation="SocialConnectorRemoveButton"
                            />
                        </div>
                    )
                    }
                </SocialConnectorContainer>
            );
        })}:
    </DetailWrapper>
};

export default function SocialConnectorForm({
    key,
    handleSubmit,
    isSaving,
    initialValues,
    selectedEntityId,
    userHasUpdatePermission,
    inherited }) {
    return (<Wrapper>
        <FieldArray
            name="socialConnectorProperties"
            rerenderOnEveryChange
            component={SocialConnectorField}
            validate={value => {
                    return !value || value.size === 0 ||
                        value.find(a => !a.get('label') || !a.get('value')) !== undefined
                        ? 'Invalid Label Data'
                        : undefined
            }}
            props={{ disabled: inherited || isSaving, userHasUpdatePermission, inherited }}
        />
    </Wrapper>)
}

SocialConnectorForm.propTypes = {
    isSaving: PropTypes.bool,
    inherited: PropTypes.bool,
    userHasUpdatePermission: PropTypes.bool,
    selectedEntityId: PropTypes.string,
    key: PropTypes.string
};

SocialConnectorField.propTypes = {
    disabled: PropTypes.bool,
    inherited: PropTypes.bool,
    userHasUpdatePermission: PropTypes.bool,
    fields: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};